import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider, createTheme } from '@mui/material';
import { CssBaseline } from '@mui/material';
import App from './App';
import './css/fonts.css';

// Suppress ResizeObserver warnings
const resizeObserverErrHandler = (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
    if (resizeObserverErr) {
      resizeObserverErr.style.display = 'none';
    }
    e.stopImmediatePropagation();
  }
};
window.addEventListener('error', resizeObserverErrHandler);

// Detect Chrome on iOS and add class to body for CSS targeting
const isChromeiOS = /CriOS/.test(navigator.userAgent) && /iPhone|iPad|iPod/.test(navigator.userAgent);
if (isChromeiOS) {
  document.body.classList.add('chrome-ios');
}

// Detect tablets (iPad, Android tablets, unfolded foldables) and add class to <html> for CSS targeting.
// iPadOS and Android tablets often send a desktop user agent, so use touch support + the screen's
// shorter side (600px = Android's tablet threshold) instead of the UA.
const isTablet = navigator.maxTouchPoints > 1 && Math.min(window.screen.width, window.screen.height) >= 600;
if (isTablet) {
  document.documentElement.classList.add('is-tablet');
}

const theme = createTheme({
  // You can customize your theme here using your styleguide values
  palette: {
    mode: 'light',
    primary: {
      main: 'rgba(233, 80, 95, 1)', // --primary-colorscalypso-coral
    },
  },
  typography: {
    fontFamily: '"Satoshi-Regular", "Arial", sans-serif',
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);